import { useWatch } from "react-hook-form";
import { findMatchingAccumulators, getProvisionsByName } from "../../../utils/planUtils"
import FormSelect from "../../shared/FormSelect"
import { IoChevronForward, IoChevronDownOutline } from "react-icons/io5";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import ProvisionInfo from "./Provision";

const AccumMappingRider = ({ activeStep, setValue, control, errors }) => {
    if (![7, 8, 9, 10].includes(activeStep))
        return <></>

    const [collapsed, setCollapsed] = useState(true)

    const accum = useWatch({ control, name: 'accumulator' });
    const options = findMatchingAccumulators(accum).map(data => ({ value: data, label: data.rider }))

    const templateKey = useWatch({ control, name: 'template.additional.benefitPlanTemplateKey' })
    const accumFromMapping = useWatch({ control, name: 'accumulatorFromMapping' });

    const { data: rider, isPending } = useQuery({
        queryKey: ['accum', 'provisions', accumFromMapping?.label],
        queryFn: async () => await getProvisionsByName(templateKey, "OOP Max - Deductible", accumFromMapping.label),
        enabled: !!accumFromMapping,
    })

    return (
        <div>
          <FormSelect
            label={`Mapping (${options?.length})`}
            name={'accumulatorFromMapping'}
            control={control}
            options={options}
            errors={errors}
            placeholder="Select..."
            onSelectedHandler={(val) => {
                setValue('accumulatorNotFound', false)
                if (val?.value) {
                    setValue('accumulator', val.value)
                } else {
                    setValue('accumulator', null)
                }
            }} />
            {accumFromMapping &&
             <>
               {isPending ?
                <div className="loader" />
                :
                <>
                  {collapsed ?
                   <IoChevronForward style={{ cursor: 'pointer' }} onClick={() => setCollapsed(!collapsed)} size={'1.2rem'} />
                   :
                   <IoChevronDownOutline style={{ cursor: 'pointer' }} onClick={() => setCollapsed(!collapsed)} size={'1.2rem'} />}
                </>}
             </>}
            {!collapsed &&
             <>
               {isPending ?
                <div className="loader" />
                :
                <ProvisionInfo rider={rider} />}
             </>}
            <p className="clickable-link danger"
                style={{ paddingBottom: '1rem' }}
                onClick={() => {
                    setValue('accumulatorFromMapping', null)
                    setValue('accumulator', null)
                }}>
                Reset Accum
            </p>
        </div>
    )
}

export default AccumMappingRider
